import { useState, useEffect, useCallback } from "react";
import {
  HiOutlineEnvelope, HiOutlineUserPlus, HiOutlinePaperAirplane, HiOutlineCalendar,
  HiOutlineMagnifyingGlass, HiOutlineArrowDownTray, HiOutlineXMark,
  HiOutlineEye, HiOutlineEllipsisVertical, HiOutlineChevronDown,
  HiOutlineChevronLeft, HiOutlineChevronRight,
  HiOutlineArrowTrendingUp, HiOutlineArrowTrendingDown,
  HiOutlineTrash, HiOutlineNoSymbol,
} from "react-icons/hi2";
import AdminLayout from "./AdminLayout";
import { subscribersAPI } from "../services/api";
import toast from "react-hot-toast";
import BroadcastModal from "./BroadcastModal";
import "./AdminSubscribers.css";

const SOURCES = ["All Sources","Hero","Footer","Contact","Donate","Application"];

const SUB_STAT_DEFS = [
  { label:"Total Subscribers", Icon:HiOutlineEnvelope,      color:"#e05a2b", bg:"rgba(var(--admin-rust-rgb), 0.12)",  prev:"prev_total"     },
  { label:"New This Month",    Icon:HiOutlineUserPlus,       color:"#16a34a", bg:"rgba(22,163,74,0.12)",  prev:"prev_new_month" },
  { label:"This Week",         Icon:HiOutlinePaperAirplane,  color:"#7c3aed", bg:"rgba(124,58,237,0.12)", prev:"prev_week"      },
  { label:"Today",             Icon:HiOutlineCalendar,       color:"#d97706", bg:"rgba(217,119,6,0.12)",  prev:"prev_today"     },
];

const pct = (curr, prev) => {
  if (!prev || prev === 0) return null;
  const d = ((curr - prev) / prev) * 100;
  return { value: Math.abs(d).toFixed(1), up: d >= 0 };
};

const SOURCE_ICON = (src) => {
  const m = { "Hero":HiOutlineEnvelope, "Footer":HiOutlinePaperAirplane, "Contact":HiOutlineEnvelope, "Donate":HiOutlineEnvelope, "Application":HiOutlineCalendar };
  const c = { "Hero":"#e05a2b","Footer":"#7c3aed","Contact":"#16a34a","Donate":"#e05a2b","Application":"#2563eb" };
  return { Icon: m[src] || HiOutlineEnvelope, color: c[src] || "#6b6258" };
};

/* Row context menu */
function RowMenu({ sub, onView, onUnsubscribe, onDelete }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ position:"relative" }}>
      <button type="button" className="a-btn a-btn--ghost aap__action-btn"
        onClick={e => { e.stopPropagation(); setOpen(v => !v); }}>
        <HiOutlineEllipsisVertical />
      </button>
      {open && (
        <>
          <div style={{ position:"fixed",inset:0,zIndex:49 }} onClick={() => setOpen(false)} />
          <div className="asu__row-menu">
            <button onClick={() => { onView(sub); setOpen(false); }}>
              <HiOutlineEye /> View Details
            </button>
            <button onClick={() => { onUnsubscribe(sub.id); setOpen(false); }}>
              <HiOutlineNoSymbol /> Unsubscribe
            </button>
            <div className="asu__row-menu-divider" />
            <button className="asu__row-menu-delete" onClick={() => { onDelete(sub.id); setOpen(false); }}>
              <HiOutlineTrash /> Delete
            </button>
          </div>
        </>
      )}
    </div>
  );
}

function DetailPanel({ sub, onClose, onDelete, onUnsubscribe }) {
  const si = SOURCE_ICON(sub.source);
  const subDate = sub.created_at ? new Date(sub.created_at) : null;
  const displayDate = subDate ? subDate.toLocaleDateString("en-US",{year:"numeric",month:"long",day:"numeric"}) : (sub.subscribed || "—");
  const displayTime = subDate ? subDate.toLocaleTimeString([],{hour:"2-digit",minute:"2-digit"}) : (sub.time || "");
  const initials = sub.email.split("@")[0].slice(0,2).toUpperCase();

  return (
    <div className="asu__detail">
      <div className="asu__detail-head">
        <h3 className="asu__detail-title">Subscriber Details</h3>
        <button className="asu__detail-close" onClick={onClose}><HiOutlineXMark /></button>
      </div>

      <div className="asu__detail-user">
        <div className="asu__detail-avatar" style={{ background:"#b85c38" }}>{initials}</div>
        <div>
          <p className="asu__detail-name">{sub.email.split("@")[0].replace(/[._]/g," ").replace(/\b\w/g,c=>c.toUpperCase())}</p>
          <p className="asu__detail-email">{sub.email}</p>
          <span className={`abadge ${sub.status==="Active"?"asu__badge--active":"asu__badge--unsub"}`}>{sub.status}</span>
        </div>
      </div>

      <div className="asu__detail-info">
        <p className="asu__detail-info-text">Subscribed on {displayDate} {displayTime && `at ${displayTime}`}</p>
        <div className="asu__detail-source">
          <span className="asu__detail-source-label">Source</span>
          <div className="asu__source-pill">
            <si.Icon style={{ color:si.color, fontSize:"0.85rem" }} />
            <span>{sub.source}</span>
          </div>
        </div>
      </div>

      <div className="asu__detail-section">
        <p className="asu__detail-section-title">Recent Activity</p>
        <div className="asu__activity-item">
          <div className="asu__activity-icon"><HiOutlineEnvelope /></div>
          <div>
            <p className="asu__activity-label">Subscribed to newsletter</p>
            <p className="asu__activity-time">{displayDate} {displayTime && `at ${displayTime}`}</p>
          </div>
        </div>
      </div>

      <div className="asu__detail-section">
        <p className="asu__detail-section-title">Actions</p>
        <a href={`mailto:${sub.email}`} className="a-btn a-btn--outline asu__action-full" style={{ marginBottom:"0.5rem" }}>
          <HiOutlineEnvelope /> Send Email
        </a>
        {sub.status === "Active" && (
          <button type="button" className="asu__unsub-btn"
            onClick={() => { onUnsubscribe(sub.id); onClose(); }}>
            <HiOutlineNoSymbol /> Mark as Unsubscribed
          </button>
        )}
        <button type="button" className="asu__delete-btn"
          onClick={() => {
              toast((t) => (
                <div style={{ display:"flex", flexDirection:"column", gap:"0.5rem" }}>
                  <p style={{ margin:0, fontWeight:700 }}>Delete subscriber?</p>
                  <p style={{ margin:0, fontSize:"0.78rem", color:"#6b6258" }}>This cannot be undone.</p>
                  <div style={{ display:"flex", gap:"0.5rem" }}>
                    <button onClick={() => { toast.dismiss(t.id); onDelete(sub.id); onClose(); }}
                      style={{ background:"#dc2626", color:"#fff", border:"none", borderRadius:"5px", padding:"0.35rem 0.75rem", cursor:"pointer", fontWeight:700, fontSize:"0.78rem" }}>
                      Delete
                    </button>
                    <button onClick={() => toast.dismiss(t.id)}
                      style={{ background:"#f3f4f0", border:"none", borderRadius:"5px", padding:"0.35rem 0.75rem", cursor:"pointer", fontSize:"0.78rem" }}>
                      Cancel
                    </button>
                  </div>
                </div>
              ), { duration: Infinity, style: { maxWidth:"320px" } });
            }}>
          <HiOutlineTrash /> Delete Subscriber
        </button>
        <p className="asu__delete-warn">This will permanently remove the subscriber and all associated data.</p>
      </div>
    </div>
  );
}

export default function AdminSubscribers() {
  const [search, setSearch]     = useState("");
  const [source, setSource]     = useState("All Sources");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo]     = useState("");
  const [showDate, setShowDate] = useState(false);
  const [selected, setSelected] = useState(null);
  const [subs, setSubs]         = useState([]);
  const [stats, setStats]       = useState({});
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading]   = useState(true);
  const [page, setPage]         = useState(1);
  const [checked, setChecked]    = useState(new Set());
  const [selectAll, setSelectAll]= useState(false);
  const [showBroadcast, setShowBroadcast] = useState(false);

  const fetchSubs = useCallback(async () => {
    setLoading(true);
    try {
      const params = { page, limit:10 };
      if (search)                   params.search    = search;
      if (source !== "All Sources") params.source    = source;
      if (dateFrom)                 params.date_from = dateFrom;
      if (dateTo)                   params.date_to   = dateTo;
      const res = await subscribersAPI.list(params);
      setSubs(res.data || []);
      setTotalCount(res.pagination?.total || 0);
      if (res.stats) setStats(res.stats);
    setChecked(new Set()); setSelectAll(false);
    } catch (err) { console.error(err.message); }
    finally { setLoading(false); }
  }, [search, source, dateFrom, dateTo, page]);

  useEffect(() => { fetchSubs(); }, [fetchSubs]);

  const handleDelete = async (id) => {
    const tid = toast.loading("Deleting subscriber…");
    try {
      await subscribersAPI.delete(id); fetchSubs(); setSelected(null);
      toast.success("Subscriber deleted.", { id: tid });
    } catch (err) { toast.error("Delete failed: " + err.message, { id: tid }); }
  };

  const handleUnsubscribe = async (id) => {
    const tid = toast.loading("Updating subscriber…");
    try {
      await subscribersAPI.unsubscribe(id); fetchSubs();
      toast.success("Subscriber marked as unsubscribed.", { id: tid });
    } catch (err) { toast.error("Failed: " + err.message, { id: tid }); }
  };

  const [exportLoading, setExportLoading] = useState(false);

  const toggleSelectAll = () => {
    if (selectAll) {
      setChecked(new Set());
      setSelectAll(false);
    } else {
      setChecked(new Set(subs.map(s => s.id)));
      setSelectAll(true);
    }
  };

  const toggleCheck = (id) => {
    setChecked(prev => {
      const n = new Set(prev);
      n.has(id) ? n.delete(id) : n.add(id);
      if (n.size !== subs.length) setSelectAll(false);
      else setSelectAll(true);
      return n;
    });
  };

  const handleExport = async () => {
    setExportLoading(true);
    try {
      const ids = checked.size > 0 ? [...checked] : [];
      await subscribersAPI.exportCsv(ids);
      const msg = ids.length > 0
        ? `Exported ${ids.length} selected subscriber${ids.length > 1 ? "s" : ""}.`
        : "Exported all subscribers.";
      toast.success(msg);
    } catch (err) {
      toast.error("Export failed: " + err.message);
    } finally {
      setExportLoading(false);
    }
  };

  const totalPages = Math.max(1, Math.ceil(totalCount / 10));

  /* Stat values: use API stats if available, else derive from local data */
  const statValues = [
    stats.total        ?? totalCount,
    stats.new_month    ?? subs.filter(s => { const d = new Date(s.created_at); const now = new Date(); return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear(); }).length,
    stats.this_week    ?? 0,
    stats.today        ?? 0,
  ];
  const statPrevs = [stats.prev_total, stats.prev_new_month, stats.prev_week, stats.prev_today];

  return (
    <AdminLayout pageTitle="Subscribers" pageSubtitle="Manage all email subscribers and newsletter sign-ups." permission="subscribers.view">

      {/* Stat cards */}
      <div className="asu__stats-grid">
        {SUB_STAT_DEFS.map((s, i) => {
          const val = statValues[i];
          const trend = pct(val, statPrevs[i]);
          return (
            <div key={s.label} className="acard asu__stat-card">
              <div className="asu__stat-top">
                <div className="asu__stat-icon" style={{ background:s.bg }}>
                  <s.Icon style={{ color:s.color, fontSize:"1.1rem" }} />
                </div>
                <p className="asu__stat-label">{s.label}</p>
              </div>
              <p className="asu__stat-value">{typeof val === "number" ? val.toLocaleString() : "—"}</p>
              {trend ? (
                <p className={`asu__stat-change ${trend.up?"up":"down"}`}>
                  {trend.up ? <HiOutlineArrowTrendingUp /> : <HiOutlineArrowTrendingDown />}
                  {trend.value}% vs last period
                </p>
              ) : (
                <p className="asu__stat-change" style={{ color:"#9ca3af" }}>No comparison yet</p>
              )}
            </div>
          );
        })}
      </div>

      <div className={`asu__layout ${selected ? "asu__layout--detail" : ""}`}>
        <div className="asu__table-panel">
          {/* Bulk action bar */}
          {checked.size > 0 && (
            <div className="abulk__bar">
              <span className="abulk__count">{checked.size} selected</span>
              <button type="button" className="a-btn a-btn--outline abulk__btn"
                onClick={handleExport} disabled={exportLoading}>
                <HiOutlineArrowDownTray /> {exportLoading ? "Exporting…" : "Export Selected"}
              </button>
              <button type="button" className="a-btn a-btn--ghost abulk__btn"
                onClick={() => { setChecked(new Set()); setSelectAll(false); }}>
                Clear Selection
              </button>
            </div>
          )}

          {/* Filters */}
          <div className="asu__filters">
            <div className="asu__search-wrap">
              <HiOutlineMagnifyingGlass className="asu__search-icon" />
              <input type="text" className="asu__search" placeholder="Search email..."
                value={search} onChange={e => { setSearch(e.target.value); setPage(1); }} />
            </div>

            <div className="aap__select-wrap">
              <select className="aap__filter-select" value={source}
                onChange={e => { setSource(e.target.value); setPage(1); }}>
                {SOURCES.map(s => <option key={s}>{s}</option>)}
              </select>
              <HiOutlineChevronDown className="aap__select-icon" />
            </div>

            {/* Date range */}
            <div className="aap__date-wrap">
              <button type="button" className="asu__date-filter"
                onClick={() => setShowDate(v => !v)}>
                <HiOutlineCalendar />
                <span>{dateFrom ? `${dateFrom}${dateTo ? ` → ${dateTo}` : ""}` : "All Dates"}</span>
                <HiOutlineChevronDown />
              </button>
              {showDate && (
                <div className="aap__date-dropdown">
                  <div className="aap__date-picker">
                    <div className="aap__date-field">
                      <label>From</label>
                      <input type="date" value={dateFrom} onChange={e => { setDateFrom(e.target.value); setPage(1); }} />
                    </div>
                    <div className="aap__date-field">
                      <label>To</label>
                      <input type="date" value={dateTo} onChange={e => { setDateTo(e.target.value); setPage(1); }} />
                    </div>
                    <button type="button" className="a-btn a-btn--outline"
                      style={{ fontSize:"0.75rem", padding:"0.35rem 0.6rem" }}
                      onClick={() => { setDateFrom(""); setDateTo(""); setPage(1); setShowDate(false); }}>
                      Clear
                    </button>
                  </div>
                </div>
              )}
            </div>

            <div className="asu__filters-right" style={{ display:"flex", gap:"0.5rem" }}>
              <button type="button" className="a-btn a-btn--rust"
                onClick={() => setShowBroadcast(true)}
                title={checked.size > 0 ? `Email ${checked.size} selected` : "Email all subscribers"}>
                <HiOutlineEnvelope /> {checked.size > 0 ? `Email ${checked.size}` : "Email Subscribers"}
              </button>
              <button type="button" className="a-btn a-btn--outline" onClick={handleExport} disabled={exportLoading}>
                <HiOutlineArrowDownTray /> {exportLoading ? "Exporting…" : checked.size > 0 ? `Export ${checked.size}` : "Export All"}
              </button>
            </div>
          </div>

          <div className="acard asu__table-card">
            <table className="asu__table">
              <thead>
                <tr>
                  <th className="asu__th-check"><input type="checkbox" className="aap__checkbox" checked={selectAll} onChange={toggleSelectAll} /></th>
                  <th>Email</th>
                  <th>Source</th>
                  <th>Date Subscribed ↓</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan="6" style={{ textAlign:"center", padding:"3rem", color:"#9ca3af" }}>Loading…</td></tr>
                ) : subs.length === 0 ? (
                  <tr><td colSpan="6" style={{ textAlign:"center", padding:"3rem", color:"#9ca3af" }}>No subscribers found.</td></tr>
                ) : subs.map(s => {
                  const si = SOURCE_ICON(s.source);
                  const d = s.created_at ? new Date(s.created_at) : null;
                  return (
                    <tr key={s.id}
                      className={`aap__row ${selected?.id===s.id?"aap__row--selected":""}`}
                      onClick={() => setSelected(s)}>
                      <td onClick={e=>e.stopPropagation()}><input type="checkbox" className="aap__checkbox" checked={checked.has(s.id)} onChange={()=>toggleCheck(s.id)} /></td>
                      <td className="asu__email-cell">{s.email}</td>
                      <td>
                        <div className="asu__source-row">
                          <si.Icon style={{ color:si.color, fontSize:"0.9rem" }} />
                          <span>{s.source}</span>
                        </div>
                      </td>
                      <td>
                        <div className="aap__submitted">
                          <p>{d ? d.toLocaleDateString("en-US",{year:"numeric",month:"short",day:"numeric"}) : "—"}</p>
                          <p className="aap__submitted-time">{d ? d.toLocaleTimeString([],{hour:"2-digit",minute:"2-digit"}) : ""}</p>
                        </div>
                      </td>
                      <td>
                        <span className={`abadge ${s.status==="Active"?"asu__badge--active":"asu__badge--unsub"}`}>{s.status}</span>
                      </td>
                      <td onClick={e=>e.stopPropagation()}>
                        <div className="aap__row-actions">
                          <button type="button" className="a-btn a-btn--ghost aap__action-btn"
                            onClick={() => setSelected(s)}>
                            <HiOutlineEye />
                          </button>
                          <RowMenu sub={s}
                            onView={() => setSelected(s)}
                            onUnsubscribe={handleUnsubscribe}
                            onDelete={(id) => {
              toast((t) => (
                <div style={{ display:"flex", flexDirection:"column", gap:"0.5rem" }}>
                  <p style={{ margin:0, fontWeight:700 }}>Delete subscriber?</p>
                  <p style={{ margin:0, fontSize:"0.78rem", color:"#6b6258" }}>This cannot be undone.</p>
                  <div style={{ display:"flex", gap:"0.5rem" }}>
                    <button onClick={() => { toast.dismiss(t.id); handleDelete(id); }}
                      style={{ background:"#dc2626", color:"#fff", border:"none", borderRadius:"5px", padding:"0.35rem 0.75rem", cursor:"pointer", fontWeight:700, fontSize:"0.78rem" }}>Delete</button>
                    <button onClick={() => toast.dismiss(t.id)}
                      style={{ background:"#f3f4f0", border:"none", borderRadius:"5px", padding:"0.35rem 0.75rem", cursor:"pointer", fontSize:"0.78rem" }}>Cancel</button>
                  </div>
                </div>
              ), { duration: Infinity, style: { maxWidth:"320px" } });
            }}
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            <div className="aap__pagination">
              <p className="aap__pagination-info">Showing {totalCount>0?`${((page-1)*10)+1}–${Math.min(page*10,totalCount)} of ${totalCount}`:0} subscribers</p>
              <div className="aap__pagination-pages">
                <button type="button" className="aap__page-btn" disabled={page===1} onClick={() => setPage(p=>p-1)}><HiOutlineChevronLeft /></button>
                {Array.from({ length:Math.min(5, totalPages) },(_,i)=>i+1).map(p=>(
                  <button key={p} type="button" className={`aap__page-btn ${page===p?"aap__page-btn--active":""}`} onClick={()=>setPage(p)}>{p}</button>
                ))}
                <button type="button" className="aap__page-btn" disabled={page>=totalPages} onClick={()=>setPage(p=>p+1)}><HiOutlineChevronRight /></button>
              </div>
              <div className="aap__select-wrap">
                <select className="aap__page-size"><option>10 / page</option><option>20 / page</option></select>
                <HiOutlineChevronDown className="aap__select-icon" />
              </div>
            </div>
          </div>
        </div>

        {selected && (
          <DetailPanel
            sub={selected}
            onClose={() => setSelected(null)}
            onDelete={handleDelete}
            onUnsubscribe={handleUnsubscribe}
          />
        )}
      </div>
      {/* Broadcast modal */}
      {showBroadcast && (
        <BroadcastModal
          recipientType="subscribers"
          selectedIds={[...checked]}
          totalCount={totalCount}
          onSend={(payload) => subscribersAPI.broadcast(payload)}
          onClose={() => setShowBroadcast(false)}
        />
      )}
    </AdminLayout>
  );
}
